import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import conf from '~/app/conf'
import type { DevtoolsOptions } from 'zustand/esm/middleware/devtools'
import type { StoreApi } from 'zustand'

export const wrapWithDevtools = <T>(
  fn: (set: StoreApi<T>['setState'], get: StoreApi<T>['getState'], store: StoreApi<T>) => T,
  devtoolsOptions?: DevtoolsOptions
) => {
  return conf.environment !== 'prod' ? devtools(fn, devtoolsOptions) : fn
}

export const createBaseStore = <T>(
  fn: (set: StoreApi<T>['setState'], get: StoreApi<T>['getState'], store: StoreApi<T>) => T,
  devtoolsOptions?: DevtoolsOptions
) => {
  return create<T>()(subscribeWithSelector(wrapWithDevtools(fn, devtoolsOptions)))
}
